import ActionType from 'actions/ActionType'

export default (state = {}, action) => {
  const switchObj = {
    // Implement generic data later, there will have to be a flag passed
    // to the request that indicates the response will be paginated.
    // Once this is done, move conversationListCursor.js state to here.

    // [ActionType.Data.LIST_REQUEST]: () => {
    //   if (action.entityType) {

    //   }
    // },
    // [ActionType.Data.LIST_SUCCESS]: () => {
    //   if (action.cursor && action.entityType) {
    //     return { ...state, [action.entityType]: {
    //       ...state?.[action.entityType],
    //       loading: false,
    //       cursor: action.cursor,
    //     }}
    //   }
    //   return state
    // },
    [ActionType.Campaign.LIST_CONTACTS_IN_STAGE_REQUEST]: () => {
      return {
        ...state,
        contactsInStage: {
          ...state.contactsInStage,
          loading: true,
        },
      }
    },
    [ActionType.Campaign.LIST_CONTACTS_IN_STAGE_SUCCESS]: () => {
      return {
        ...state,
        contactsInStage: {
          ...state.contactsInStage,
          loading: false,
          cursor: action.cursor,
        },
      }
    },
    [ActionType.Campaign.CLICK_CONTACT_COUNT]: () => {
      if (!action.payload) {
        return {
          ...state,
          contactsInStage: undefined,
        }
      }
      return state
    },
  }

  // If the function returns falsey, a ternary is required because
  // if `|| state` is used, state will remain the same
  return switchObj?.[action?.type] ? switchObj[action?.type]() : state
}
